import { c as _c } from "react/compiler-runtime";
import React from 'react';
import imageComingSoon from 'assets/icons/image-coming-soon.svg';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const ProductCardImageComingSoon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img alt="" className="absolute w-[80%] max-w-full h-[80%] max-h-full top-[10%] left-[10%] object-contain" src={isNewConsumerApp ? "/static/assets/icons/image-coming-soon.svg" : imageComingSoon} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ProductCardImageComingSoon;